import AxiosControl from '../components/axios/AxiosControl'
import { toastSuccess, toastError } from '../components/swal/toast'
const Axios = AxiosControl()

export const getTasks = (params) => async (dispatch) => {
    dispatch({ type: 'TASKS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/tasks', {
            params,
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'TASKS_SUCCESS', payload: data.tasks })
        }
    } catch (error) {
        dispatch({ type: 'TASKS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const addTask = (task) => async (dispatch) => {
    dispatch({ type: 'TASKS_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/teacher/tasks', task, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'TASK_ADD_SUCCESS', payload: data.task })
        }
    } catch (error) {
        dispatch({ type: 'TASKS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getTask = (taskId) => async (dispatch) => {
    dispatch({ type: 'TASKS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/tasks/' + taskId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'TASK_SUCCESS', payload: data.task })
        }
    } catch (error) {
        dispatch({ type: 'TASKS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const gradeTask = (taskId, grade) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/tasks/' + taskId + '/grade', grade, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            toastSuccess(data.message || 'Tarea calificada correctamente')
            return true
        }
        return false
    } catch (error) {
        toastError(error.response?.data?.message || 'Error al calificar la tarea')
        return false
    }
}
